import script from "./PreviouslySoldTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviouslySoldTable.vue?vue&type=script&setup=true&lang=js"

import "./PreviouslySoldTable.vue?vue&type=style&index=0&id=38cabda6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cabda6"]])

export default __exports__